module.exports = __webpack_public_path__ + "70cbc3cbad57037fb58efe367d926c24.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/anna-henningsen.jpg
// module id = 503
// module chunks = 0